<template>
  <div class="AttendanceStatusReport">
    <section-search-panel :accessTo="61" @search="search" />
    <box class="mt-2" :title="$t('personelList')">
      <div class="vacationList">
        <div v-if="list.length > 0">
          <attendance-status-report-list-web
            :pagination="true"
            :list="list"
            class="hidden-sm-and-down"
            @onClick="onClick"
          />
          <attendance-status-report-list-mob
            @onClick="onClick"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <empty-list />
        </div>
      </div>
    </box>

    <box class="mt-2" :title="$t('tableColorsGuide')">
      <div class="pa-1">
        <v-row>
          <v-col cols="12" sm="6" v-for="(item, i) in colorsGuide" :key="i">
            <div class="d-flex pa-1">
              <div
                width="20px"
                height="20px"
                :class="[item.class, 'color-box']"
              ></div>
              <span class="px-1">{{ item.title }}</span>
            </div>
          </v-col>
        </v-row>
      </div>
    </box>
  </div>
</template>

<script>
import AttendanceStatusReportListMob from "../../components/personelOperationReport/attendanceStatusList/AttendanceStatusReportListMob.vue";
import AttendanceStatusReportListWeb from "../../components/personelOperationReport/attendanceStatusList/AttendanceStatusReportListWeb.vue";
import SectionSearchPanel from "../../components/personelOperationReport/SectionSearchPanel.vue";
import ResultType from "../../model/ResultType";
export default {
  components: {
    SectionSearchPanel,
    AttendanceStatusReportListWeb,
    AttendanceStatusReportListMob,
  },
  data() {
    return {
      list: [],
      colorsGuide: [
        {
          title: "ماموریت روزانه",
          type: 1,
          class: "Orange",
        },
        {
          title: "ماموریت روزانه - تأیید نشده",
          type: 2,
          class: "OrangeRed",
        },
        {
          title: "ماموریت روزانه - تأیید شده - انتقال داده نشده",
          type: 3,
          class: "DarkOrange",
        },
        {
          title: "ماموریت ساعتی",
          type: 4,
          class: "LightBlue",
        },
        {
          title: " ماموریت ساعتی - تأیید نشده",
          type: 5,
          class: "SlateBlue",
        },
        {
          title: " ماموریت ساعتی - تأیید شده - انتقال داده نشده",
          type: 6,
          class: "DodgerBlue",
        },
        {
          title: " مرخصی روزانه",
          type: 7,
          class: "ForestGreen",
        },
        {
          title: " مرخصی روزانه - تأیید نشده",
          type: 8,
          class: "LightSeaGreen",
        },
        {
          title: " مرخصی روزانه - تأیید شده - انتقال داده نشده",
          type: 9,
          class: "GreenYellow",
        },
        {
          title: " مرخصی ساعتی",
          type: 10,
          class: "LightSeaGreen",
        },
        {
          title: " مرخصی ساعتی - تأیید نشده",
          type: 11,
          class: "DarkOliveGreen",
        },
        {
          title: " مرخصی ساعتی - تأیید شده - انتقال داده نشده",
          type: 12,
          class: "DarkSeaGreen",
        },
        {
          title: " تاخیر سرویس",
          type: 13,
          class: "DarkMagenta",
        },
        {
          title: " حضور در سازمان",
          type: 14,
          class: "White",
        },
        {
          title: " غیبت",
          type: 0,
          class: "PaleVioletRed",
        },
      ],
    };
  },
  methods: {
    search(searchParams) {
      var params = searchParams;
      this.$store
        .dispatch("GetPersonsAttendanceStatus", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            this.list = result.data.Table;
          }
        });
    },
    onClick() {},
  },
};
</script>

<style>

.PaleVioletRed {
  background-color: palevioletred;
  color: black;
}
.Orange {
  background-color: orange;
}
.OrangeRed {
  background-color: orangered;
}
.DarkOrange {
  background-color: darkorange;
}
.LightBlue {
  background-color: lightblue;
}
.SlateBlue {
  background-color: slateblue;
}
.DodgerBlue {
  background-color: dodgerblue;
}
.ForestGreen {
  background-color: forestgreen;
}
.LightSeaGreen {
  background-color: lightseagreen;
}
.GreenYellow {
  background-color: greenyellow;
}
.LightSeaGreen {
  background-color: lightseagreen;
}
.DarkOliveGreen {
  background-color: darkolivegreen;
}
.DarkSeaGreen {
  background-color: darkseagreen;
}
.DarkMagenta {
  background-color: darkmagenta;
}
.White {
  background-color: whitesmoke;
}
</style>